import React from 'react';
import { css } from '@emotion/core';
import Tooltip from '@atlaskit/tooltip';
import Button from '@atlaskit/button';
import { Link } from 'react-router-dom';

import Scope from '../scope';
import { SearchableType } from '../types';

const rootStyles = css`
  display: flex;
  align-items: baseline;
`;

type AvailableScopesProps = {
  scopes: Set<SearchableType>;
  handleOnClick: Function;
};

const AvailableScopes: React.FC<AvailableScopesProps> = ({
  scopes,
  handleOnClick,
}: AvailableScopesProps) => (
  <div css={rootStyles}>
    <p>
      <em>Search scopes:</em>
      &nbsp;
    </p>
    {[...scopes].length === 0 && '﹣'}
    <Tooltip content="Click to add a scope to the search bar">
      <>
        {[...scopes].map(scope => (
          <Scope
            key={scope}
            scope={scope}
            onClick={() => {
              handleOnClick(scope);
            }}
          />
        ))}
      </>
    </Tooltip>
    <Button appearance="link" href="/search">
      <Link relative="path" to="/search">
        Switch to new search
      </Link>
    </Button>
  </div>
);
export default AvailableScopes;
